<mbs-modal
  class="ph-no-capture"
  [loading]="false"
  [title]="modalTitle">
  <ng-container modal-body>
    @switch (applyTo) {
      @case (applyToEnum.administrators) {
        <mbs-select-admin-utility
          [multipleSelect]="multipleSelect"
          [noDataText]="noDataText"
          [selectedIds]="selectedAdministratorIds"
          (emitChanges)="setAdministratorSelection($event)">
        </mbs-select-admin-utility>
      }
      @case (applyToEnum.companies) {
        <mbs-select-company-utility
          [disabledHint]="disabledHint"
          [disabledIds]="disabledIds"
          [multipleSelect]="multipleSelect"
          [noDataText]="noDataText"
          [selectedIds]="selectedCompanyIds"
          [showAddNewCompany]="showAddNewCompany"
          (emitChanges)="setCompanySelection($event)">
        </mbs-select-company-utility>
      }
      @case (applyToEnum.computers) {
        <mbs-select-computer-utility
          [agentType]="agentType"
          [allFilters]="allFilters"
          [isSpecificCase]="isSpecificCase"
          [multipleSelect]="multipleSelect"
          [noDataText]="noDataText"
          [optionalOrderingParams]="optionalOrderingParams"
          [osType]="osType"
          [selectedIds]="selectedComputerIds"
          [selectedValue]="selectedValue"
          [showOffline]="showOffline"
          (emitChanges)="setComputerSelection($event)">
        </mbs-select-computer-utility>
      }
      @case (applyToEnum.tags) {
        <mbs-select-tag-utility
          [multipleSelect]="multipleSelect"
          [noDataText]="noDataText"
          [selectedIds]="selectedTagIds"
          (emitChanges)="setTagSelection($event)">
        </mbs-select-tag-utility>
      }
      @default {}
    }
  </ng-container>

  <ng-container modalFooter>
    @if (showSaveBtn) {
      <mbs-button
        [type]="'primary'"
        (click)="save()">
        {{ saveButtonText }}
      </mbs-button>
    }

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="close()">
      {{ 'wizards:tryRmm.modal_cancel_btn' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
